import type { ComponentProps } from "react"
import { cn } from "@/lib/utils"

export function Kbd({ className, ...props }: ComponentProps<"kbd">) {
  return <kbd className={cn("inline-flex h-4.5 min-w-4.5 items-center justify-center rounded-sm border border-border bg-raised px-1 font-mono text-2xs text-muted-foreground", className)} {...props} />
}
